import { MuiSM, MuiMD, MuiLG, MuiXL } from "../Responsive";
/**
 * SliderSettings - This sets how many slides display and how many slides should scroll.
 * These values are defined in the "Cards to show per row" configuration
 * This is only for the Slick Slider
 * @param cardsPerRowLG - Cards to show on large screens
 * @param cardsPerRowMD - Cards to show on medium screens
 * @param cardsPerRowSM - Cards to show on small screens
 * @param cardsPerRowXS - Cards to show on extra small screens
 * @returns SliderSettings
 */
export const SliderSettings = (cardsPerRowLG = 3, cardsPerRowMD = 2, cardsPerRowSM = 2, cardsPerRowXS = 1) => {
    return {
        //Default to the largest screen size
        slidesToShow: Number(cardsPerRowLG),
        slidesToScroll: Number(cardsPerRowLG),
        arrows: true,
        infinite: false,
        //react slick slider breakpoints are max width of the screen size. Therefore, cardPerRow needs Mui breakpoints one size larger.
        responsive: [
            {
                breakpoint: MuiXL,
                settings: {
                    slidesToShow: Number(cardsPerRowLG),
                    slidesToScroll: Number(cardsPerRowLG),
                },
            },
            {
                breakpoint: MuiLG,
                settings: {
                    slidesToShow: Number(cardsPerRowMD),
                    slidesToScroll: Number(cardsPerRowMD),
                },
            },
            {
                breakpoint: MuiMD,
                settings: {
                    slidesToShow: Number(cardsPerRowSM),
                    slidesToScroll: Number(cardsPerRowSM),
                },
            },
            {
                breakpoint: MuiSM,
                settings: {
                    slidesToShow: Number(cardsPerRowXS),
                    slidesToScroll: Number(cardsPerRowXS),
                },
            },
        ],
    };
};
